import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IRenew, IRenewInput } from "@/interfaces/renew.interfaces";
import renewService from "@/services/renew.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateRenewProps = {
  formData: IRenewInput;
} & RequestsProps;

export type UseCreateRenewReturn = {
  create: (props: CreateRenewProps) => Promise<IRenew>;
} & UseLoadingReturn;

const useCreateRenew = (): UseCreateRenewReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IRenewInput>({
    operation: (formData) => renewService.createRenew(formData),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, create };
};

export default useCreateRenew;
